<template lang="pug">
  .component-backoffice-translation.row.column
    GroupedTranslation(:translations="overriddenTranslations")
      h3 Overriden translations
    GroupedTranslation(:translations="overridableTranslations")
      h3 Overridable translations
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import collect from "collect.js";
import {mapState} from "vuex";
import GroupedTranslation from "./GroupedTranslation.vue";


export default {
  name: 'TranslationList',
  components: {
    GroupedTranslation,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/Translation.vue'),
      overriddenTranslations: {},
      overridableTranslations: {},
    }
  },
  created() {
    this.loadOverridden()
    this.loadOverridable()
  },
  methods: {
    loadOverridden() {
      KeplerBackofficeSdk.translations.list.all(1, -1, (data) => {
        this.overriddenTranslations = collect(data.items).groupBy('group').all()
      })
    },
    loadOverridable() {
      KeplerBackofficeSdk.translations.list.overridable(['notifications', 'exception', 'exceptions', 'flows', 'hardware', 'paymentmethods', 'profile', 'reservation', 'reservations', 'results', 'subscription', 'rate_descriptor', 'walletables'], null,(data) => {
        this.overridableTranslations = collect(data).groupBy('group').all()
      })
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    allowedLanguages() {
      return collect(this.configuration.system.system_fields_configuration.value).first((i) => i.field === 'allowedLanguages').config.split(',')
    }
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TranslationList.vue?0461b1f7